export default "__VITE_ASSET__FqIpTV2Q__"